import React, { useState } from "react";
import { Banner } from "Shared/util/types";
import useUserContext from "Contexts/user-context";
import add from "date-fns/add";
import differenceInSeconds from "date-fns/differenceInSeconds";
import { addCookie } from "Shared/util/cookies";
import InlineSvg from "Shared/components/inline-svg";
import styles from "./base-banner.css";

type RenderProps = {
    hide: (until: Date) => void;
};

type BaseBannerProps = {
    id: Banner;
    render: (renderProps: RenderProps) => JSX.Element;
    closedUntil?: Date;
    className?: string;
};

const BaseBanner = ({
    id,
    render,
    closedUntil,
    className,
}: BaseBannerProps) => {
    const [visible, setVisible] = useState(true);
    const { user } = useUserContext();

    const hideBanner = (until: Date) => {
        setVisible(false);
        const cookieName = `KafOnline.Banner.${id}.Hidden.${user?.activeCompany?.id}${user?.id}`;
        const secondsUntilExpire = differenceInSeconds(until, new Date());
        addCookie(cookieName, "", secondsUntilExpire);
    };

    const handleClose = () => {
        const hideUntil = closedUntil ?? add(new Date(), { days: 2 });
        hideBanner(hideUntil);
    };

    const renderProps: RenderProps = {
        hide: hideBanner,
    };

    return !visible ? null : (
        <div className={`${styles.container} ${className || ""}`}>
            <div className={styles.contentContainer}>{render(renderProps)}</div>
            <InlineSvg
                src="/close.svg"
                onClick={handleClose}
                className={styles.closeContainer}
            />
        </div>
    );
};

export default BaseBanner;
